import React, { useState, useEffect, useMemo } from "react";
import { useExam } from "../../context/ExamContext";
import parse from "html-react-parser";
import stringQuestionIntervalToArray from "../../utils/stringQuestionIntervalToArray";
import useScrollToActiveQuestion from "../../hooks/useScrollToActiveQuestion";

function SentenceInputCompletion({ set }) {
  const { questionInterval, questions } = set;

  const { updateAnswer, answers } = useExam();
  const [inputs, setInputs] = useState({});
  const { activeQuestion, setActiveQuestion } = useExam();

  const allSetQuestionNumbers = useMemo(
    () => stringQuestionIntervalToArray(questionInterval),
    [questionInterval]
  );

  const scrollRef = useScrollToActiveQuestion(allSetQuestionNumbers);

  useEffect(() => {
    const initial = {};
    answers
      .filter(ans => allSetQuestionNumbers.includes(ans.questionNumber))
      .forEach(ans => {
        initial[ans.questionNumber] = ans.answer || "";
      });

    setInputs(initial);
  }, [answers, allSetQuestionNumbers]);

  useEffect(() => {
    const nextInput = document.querySelector(
      `[data-question='${+activeQuestion}']`
    );
    if (nextInput) nextInput.focus();
  }, [activeQuestion]);

  const handleInputChange = (questionNumber, value) => {
    setInputs((prev) => ({
      ...prev,
      [questionNumber]: value,
    }));
  };

  const handleBlurOrSubmit = (questionNumber) => {
    if (
      inputs[questionNumber] !==
      answers.find((a) => a.questionNumber == questionNumber)?.answer
    ) {
      updateAnswer({
        questionNumber: +questionNumber,
        answer: inputs[questionNumber] || "",
      });
    }
  };

  const handleKeyDown = (e, questionNumber) => {
    if (e.key === "Enter" || e.key === "Tab") {
      e.preventDefault();
      handleBlurOrSubmit(questionNumber);

      const nextInput = document.querySelector(
        `[data-question='${+questionNumber + 1}']`
      );

      if (nextInput) nextInput.focus();
    }
  };

  const handleClick = (questionNumber) => {
    setActiveQuestion(questionNumber);
  };

  const renderTextWithInputs = (text) => {
    return parse(
      text.replace(/\*(\d+)\*/g, (match, p1) => {
        return `<input class='droppable' data-question='${p1}' placeholder='${p1}'/>`;
      }),
      {
        replace: (domNode) => {
          if (domNode.attribs && domNode.attribs.class === "droppable") {
            const questionNumber = domNode.attribs["data-question"];

            return (
              <input
                key={questionNumber}
                data-question={questionNumber}
                style={{
                  textAlign: "center",
                  backgroundColor: "var(--background-color)",
                  color: "var(--text-color)",
                  border: "1px solid var(--text-color)",
                  margin: "3px 5px",
                  minWidth: "50px",
                }}
                value={inputs[questionNumber] || ""}
                onChange={(e) =>
                  handleInputChange(questionNumber, e.target.value)
                }
                onBlur={() => handleBlurOrSubmit(questionNumber)}
                onKeyDown={(e) => handleKeyDown(e, questionNumber)}
                onClick={() => handleClick(+questionNumber)}
                placeholder={questionNumber}
              />
            );
          }
        },
      }
    );
  };

  return (
    <div
      ref={scrollRef}
      className="input-completion"
      style={{ fontSize: "1rem", color: "black" }}
    >
      {questions.map((opt, idx) => {
        const qn = allSetQuestionNumbers[idx];

        return (
          <div
            key={qn}
            style={{ display: "flex", alignItems: "center", marginBottom: 8 }}
          >
            <div className="question-title">
              <strong
                style={{ marginLeft: "-6px" }}
                className={`inline-block question mr-[12px] px-1 ${activeQuestion === opt.questionNumber
                  ? "questionBorderActive"
                  : "questionBorder"
                  }`}
              >
                {opt.questionNumber}
              </strong>

              {renderTextWithInputs(opt.question || "No question provided")}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default SentenceInputCompletion;